import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actions from "../../actions";
import * as _ from 'lodash';
import {get as _get} from 'lodash';
import CommentsHeader from "../../components/clipstore/user/comment/header";
import CommentInput from "../../components/clipstore/user/comment/textarea";
import {getData, USER_DATA} from "../../util/storage";
import {isEmpty} from "../../util/utility";
import assets from "../../util/assets";
import comment_util from "../../util/clipstore/user/comment";
import video_util from "../../util/clipstore/user/video_details";
import InfiniteScroll from "react-infinite-scroll-component";
import CommentListItem from "../../components/clipstore/user/comment/list-item";
import Loading from "react-loading-animation";

class Comments extends Component {
    constructor() {
        super();
        this.state = {
            type: 'video',
            uuid: '',
            commentText: '',
            replyText: '',
            currentUser: {
                profile_pic: assets.user_placeholder
            },

            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,

            commentList: [],
            deleteComment: {},
            repliedComment: {},
        }
    }

    componentDidMount() {
        this.init();
        getData(USER_DATA).then((data) => {
            if (!isEmpty(data)) {
                console.log("componentDidMount >> USER_DATA", data)
                this.setState({
                    currentUser: data
                })
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //this will be called for every pagination we perform
        if (nextProps.get_comments && nextProps.get_comments.payload !== this.props.get_comments.payload) {

            if (nextProps.get_comments.payload &&
                nextProps.get_comments.payload.hasOwnProperty("success") &&
                nextProps.get_comments.payload.success.hasOwnProperty("data") &&
                nextProps.get_comments.payload.success.data.hasOwnProperty("data")) {

                let data = nextProps.get_comments.payload.success.data;
                let commentList = data.data;

                console.log("UNSAFE_componentWillReceiveProps >> commentList", data)

                if (commentList.length > 0) {
                    commentList = this.state.commentList.concat(commentList)
                } else {
                    commentList = this.state.commentList;
                }

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) < parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.data.length,
                    totalItems: parseInt(data.total),
                    commentList,
                    reset: false
                }, () => {
                    // if (this.state.hasMore && this.state.currentPage < 3) {
                    //     this.loadNextPage();
                    // }
                })
            }
        }


        //response for create comment
        comment_util.apiUpdate(nextProps, "create_comment", () => {
            this.setCommentText("")
            this.addElementFromArray(nextProps.create_comment.payload.success.data);
        }, () => {
            this.props.resetCreateComment();
        })

        //response for create reply
        comment_util.apiUpdate(nextProps, "create_reply", () => {
            this.updateReplyCountInArray(this.state.repliedComment);
        }, () => {
            this.props.resetCreateReply();
        })

        //response for update comment
        comment_util.apiUpdate(nextProps, "update_comment", () => {
            this.updateElementFromArray(nextProps.update_comment.payload.success.data);
        }, () => {
            this.props.resetUpdateComment();
        })

        //response for delete comment
        comment_util.apiUpdate(nextProps, "delete_comment", () => {
            this.removeElementFromArray(this.state.deleteComment);
        },()=>{
            this.props.resetDeleteComment();
        })
    }

    addElementFromArray = (commentObj) => {
        let commentList = this.state.commentList;
        //arr.splice(index, 0, item);
        commentList.splice(0, 0, commentObj);
        this.setState({
            commentList,
            totalItems: this.state.totalItems + 1
        })
    }

    /**
     * @function which mutates the state of commentList by removing content
     * @param commentObj
     */
    updateReplyCountInArray = (commentObj) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.commentList, (o) => {
            return o.comment_id === commentObj.comment_id;
        });

        //copy the element
        let commentList = this.state.commentList;

        //Update index element from index
        commentList[index] = {
            ...commentObj,
            reply_count: commentObj.reply_count + 1
        };

        this.setState({
            commentList
        })
    };

    /**
     * @function which mutates the state of commentList by removing content
     * @param commentObj
     */
    updateElementFromArray = (commentObj) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.commentList, (o) => {
            return o.comment_id === commentObj.comment_id;
        });

        //copy the element
        let commentList = this.state.commentList;

        //Update index element from index
        commentList[index] = commentObj;

        this.setState({
            commentList
        })
    };

    /**
     * @function which mutates the state of commentList by removing content
     * @param commentObj
     */
    removeElementFromArray = (commentObj) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.commentList, (o) => {
            return _.isMatch(o, commentObj)
        });

        //add the element
        let commentList = this.state.commentList;

        //Remove 1 element from index 3
        commentList.splice(index, 1);

        this.setState({
            commentList,
            totalItems: this.state.totalItems - 1
        })
    };

    init = () => {
        this.setState({
            type: comment_util.getType(this.props),
            uuid: this.props.match.params.id
        }, () => {
            comment_util.getCommentListAPI(this.props, this.state.type, this.state.uuid, this.state.currentPage);
        })
    }

    setCommentText = (value) => {
        this.setState({
            commentText: value
        })
    }

    setReplyText = (value) => {
        this.setState({
            replyText: value
        })
    }

    loadNextPage = () => {

        console.log("loadNextPage", {
            hasMore: this.state.hasMore,
            currentPage: this.state.currentPage
        });

        if (this.state.hasMore) {
            let currentPage = this.state.currentPage;
            currentPage = currentPage + 1;

            this.setState({
                currentPage
            }, () => {
                comment_util.getCommentListAPI(this.props, this.state.type, this.state.uuid, this.state.currentPage);
            })
        }
    }

    setDeleteComment = (comment) => {
        this.setState({
            deleteComment: comment
        })
    }

    setRepliedComment = (comment) => {
        this.setState({
            repliedComment: comment
        })
    }

    showLogin = () => {
        this.props.history.push(
            {
                pathname: '/login',
                state: {
                    basePath: this.props.history.location.pathname,
                    search: _get(this.props, 'history.location.search', '')
                }
            }
        );
    };

    render() {

        return (
            <div>
                <CommentsHeader amountComments={this.state.commentList.length > 0 ? this.state.totalItems : 0}/>
                <CommentInput
                    showLogin={this.showLogin}
                    profile_pic={this.state.currentUser.profile_pic}
                    user_type={"user"}
                    text={this.state.commentText}
                    setText={this.setCommentText}
                    isFetching={this.props.create_comment.isFetching}
                    actionText={"COMMENT"}
                    onActionClick={() => {
                        comment_util.createCommentAPI(this.props, {
                            "type": this.state.type,
                            "uuid": this.state.uuid,
                            "text": this.state.commentText,
                            "device": this.props.device
                        })
                    }}
                />

                <InfiniteScroll
                    className="user-list-infinite-scroll-component"
                    dataLength={this.state.commentList.length}
                    next={this.loadNextPage}
                    hasMore={this.state.hasMore}
                    loader={<Loading/>}
                    endMessage={<span/>}>

                    {
                        this.state.commentList.map((comment, index) => {
                            return (
                                <CommentListItem
                                    showLogin={this.showLogin}
                                    {...this.props}
                                    key={`${comment.comment_id}`}
                                    comment={comment}
                                    currentUser={this.state.currentUser}
                                    setDeleteComment={this.setDeleteComment}
                                    setRepliedComment={this.setRepliedComment}
                                    type="comment"
                                />
                            )
                        })
                    }

                </InfiniteScroll>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        get_comments: state.get_comments,
        create_comment: state.create_comment,
        create_reply: state.create_reply,
        update_comment: state.update_comment,
        delete_comment: state.delete_comment,
    };
}

export default connect(mapStateToProps, actions)(Comments);